// extracted by mini-css-extract-plugin
export default {"addRoleContainer":"index_addRoleContainer__Iz2mb"};